export enum TopNavProfileOptionName {
  Logout = "Logout",
  MyProfile = "My Profile",
  ManageProgress = "Manage Progress",
}
